module.exports = __webpack_public_path__ + "img/selected1-min.1c6a1173.png";